<script lang="ts" setup>
	import type { NeedToKnowProps } from '~/components/Shared/need-to-know.vue'

	export type SuccessStepContext = {
		[id: string]: {
			desc?: string
			complete: boolean
			disabled?: boolean
			icon: {
				name: string
				dir?: string
				pathClass?: string
			}
		}
	}

	defineProps<{
		successStep?: SuccessStepContext
		needToKnow?: NeedToKnowProps
		callbackLink?: string
		btnText?: string
	}>()
</script>

<template>
	<div
		class="mx-auto mt-2 flex min-h-[700px] w-full max-w-[628px] flex-col items-center justify-center py-16 sm:mt-10 sm:border sm:px-8"
	>
		<lazy-tools-icon dir="fill" icon="success-check" />
		<shared-header
			class="mt-10 text-center"
			title="Payment Successful"
			title-class="text-xl"
			sub-title="Now, it's time to add your staff and proceed with activation to ensure full coverage."
			sub-title-class="sm:text-base font-medium"
		/>
		<div class="my-12 w-full">
			<ul
				v-if="successStep"
				class="justify- min-h-[232px] w-full rounded bg-[#f5f6fa] px-3 py-4 sm:px-16 md:px-8"
			>
				<template v-for="(v, k) in successStep" :key="k">
					<li v-if="!v?.disabled" class="line-divider relative flex items-center gap-x-3 py-5 sm:gap-x-5">
						<div
							class="relative z-10 flex h-[48px] w-[48px] flex-none items-center justify-center rounded-full"
							:class="{
								'bg-gray-400': v.complete,
								'bg-purple-500': !v.complete
							}"
						>
							<lazy-tools-icon
								:height="18"
								:width="18"
								:dir="v.icon?.dir || 'fill'"
								:icon="v.icon.name"
								:path-class="`fill-white opacity-100 ${v.icon.pathClass}`"
							/>
						</div>
						<div>
							<span
								class="text-sm font-normal sm:text-base"
								:class="{
									'text-gray-500': v.complete,
									'text-purple-500': !v.complete
								}"
							>
								{{ k }}
							</span>
							<p v-show="v.desc" class="text-xs text-gray-500">
								{{ v.desc }}
							</p>
						</div>
					</li>
				</template>
			</ul>
			<shared-need-to-know v-if="needToKnow" :need-to-know="needToKnow" class="bg-[#f5f6fa]" />
		</div>

		<slot name="button">
			<nuxt-link :to="callbackLink" class="default-btn w-full justify-center bg-primary-2 capitalize">
				<slot name="btn-text">{{ btnText }}</slot>
			</nuxt-link>
		</slot>
	</div>
</template>

<style scoped>
	.line-divider:not(:last-child) {
		@apply before:absolute before:left-0 before:right-0 before:top-0 before:h-full before:w-0.5 before:translate-x-6 before:translate-y-7 before:bg-gray-300;
	}
</style>
